<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" i18n>Stornierung anfordern</h1>

    <form [formGroup]="orderClaimRequestForm">
      <div class="col-sm-6">
        <div class="row mb-2">
          <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Auftragsdatum</label>
          <kendo-datepicker
            class="col-sm-4"
            formControlName="orderDate"
            [(ngModel)]="orderClaimRequest.orderDate"
            [ngClass]="{
              'is-invalid':
                f['orderDate'].errors && (f['orderDate'].dirty || f['orderDate'].touched)
            }"
            >
            <!-- todo: localize -->
        </kendo-datepicker>
      </div>

      <app-form-row label="Auftragsnummer" i18n-label fieldClass="col-sm-6">
        <input
          type="text"
          formControlName="orderNumber"
          class="form-control form-control-sm"
          />
      </app-form-row>

      <app-form-row label="Seriennummer" i18n-label fieldClass="col-sm-6">
        <input
          type="text"
          formControlName="serial"
          class="form-control form-control-sm"
          />
      </app-form-row>

      <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>
        Zurück
      </button>
      <button
        class="btn btn-primary m-2"
        type="submit"
        [disabled]="!orderClaimRequestForm.valid"
        i18n
        >
        Bestätigen
      </button>
    </div>
  </form>
</div>
</div>
